angular.module('impactx.rfxsupplier').controller('RFXSupplierOfferDetailsCtrl', [
    '$scope',
    '$copyToClipboard',
    'ToastService',
    RFXSupplierOfferDetailsController
]);

function RFXSupplierOfferDetailsController($scope, $copyToClipboard, ToastService) {
    var self = this;

    self.copyCodeToClipboard = function () {
        var code = impactX.isDefined(self, 'data.offerCode.value');
        if (code) {
            $copyToClipboard.copy(code).then(function () {
                ToastService.openStandardToast(self.trns.copySuccess);
            });
        }
    };

    $scope.adjustValidDateMinDateValue = function(data) {
        data.validDateMinDateValue = isNaN(data.validFromDate.dateValue) ||
            data.validDate.minDate > data.validFromDate.dateValue ? data.validDate.minDate : data.validFromDate.dateValue;
    }

    self.changeSupplier = function(selected) {
        if (selected) {
            self.data.supplierId = selected.id;
            self.changeSupplierFunction();
        }
    };
}